const AccountingFirmSettings = () => import('@/components/Settings/AccountingFirmSettings')

export default [
	{
		component: AccountingFirmSettings,
		name: 'accounting-firm-settings-home',
		path: 'home'
	}
]
